import type { CurrentUserDto } from "@mesterplan/api-client";
import { useNetUserContext } from "@/contexts/NetUserContext";

/**
 * Returns the .NET-side current-user record including the server-resolved
 * effective permissions (scoped by X-Active-Org). Replaces the Firebase-backed
 * user object for cluster slices that have cut over to the .NET API.
 *
 * Backed by the shared <NetUserProvider>, so `GET /api/users/me` is fetched once
 * per session/active-org regardless of how many consumers call this hook — the
 * second fetch (after NetClientsProvider resolves the first org and begins
 * sending X-Active-Org) is what makes `permissions` non-empty.
 *
 * Returns `{ user: null }` when OIDC is still initialising, the user is not
 * authenticated, or the first `/me` for the active org has not returned yet.
 */
export function useNetUser(): { user: CurrentUserDto | null; isLoading: boolean } {
  return useNetUserContext();
}
